@if (mappinRuleList()) {
  <div class="flex gap-4">
    <div class="property-box-wrapper">
      <div
        class="property-box"
        [ngClass]="{'property-box--required': required()}"
      >
        {{ attributeControl().value + (required() ? '*' : '') }}
      </div>
    </div>

    <div class="flex-1">
      @for (
        mappinRule of mappingRulesFormArray().controls;
        track mappinRule;
        let index = $index
      ) {
        <div
          class="p-2 border-slate-200 last:border-b-0"
          [ngClass]="{
            'pt-2 mt-2': index > 0,
            'bg-slate-50 border-b-2': index % 2 === 0,
          }"
        >
          @if (
            index === mappingRulesFormArray().controls.length - 1 && index !== 0
          ) {
            <div class="otherwise-label">
              {{ 'SHARED_LABEL_OTHERWISE' | translate }}:
            </div>
          }
          <em-readable-mapping-rule
            class="block flex-auto"
            [mappingRule]="mappinRule.value"
          >
          </em-readable-mapping-rule>
        </div>
      }

      @if (stripHtmlControl().value) {
        <div class="flex mt-2 pt-2 gap-2">
          <em-icon name="settings"></em-icon>
          <div>{{ 'SHARED_LABEL_STRIP_HTML' | translate }}</div>
          <em-icon class="text-success-400 mr-2" name="check">check</em-icon>
        </div>
      }
    </div>
    <div class="ml-auto">
      @if (!allowDelete() && !allowReorder()) {
        <em-icon-button
          class="ml-auto"
          icon="edit"
          color=""
          (btnClick)="edit.emit()"
        ></em-icon-button>
      } @else {
        <em-icon-button
          class="ml-auto"
          icon="more_vert"
          color=""
          [matMenuTriggerFor]="actionsMenu"
        ></em-icon-button>
      }

      <mat-menu #actionsMenu="matMenu">
        <button mat-menu-item (click)="edit.emit()">
          <mat-icon>edit</mat-icon>
          <span>{{ 'SHARED_LABEL_EDIT' | translate }}</span>
        </button>

        @if (allowReorder()) {
          <button mat-menu-item [matMenuTriggerFor]="reorderMenu">
            <mat-icon>sort</mat-icon>
            <span>{{ 'SHARED_LABEL_REORDER' | translate }}</span>
          </button>
        }

        @if (allowDelete()) {
          <button mat-menu-item (click)="delete.emit()">
            <mat-icon color="danger">delete</mat-icon>
            <span>{{ 'SHARED_LABEL_DELETE' | translate }}</span>
          </button>
        }
      </mat-menu>
      <mat-menu #reorderMenu="matMenu">
        <button mat-menu-item (click)="moveToFirst.emit()">
          <mat-icon>keyboard_double_arrow_up</mat-icon>
          <span>{{ 'SHARED_LABEL_MOVE_TO_TOP' | translate }}</span>
        </button>
        <button mat-menu-item (click)="moveUp.emit()">
          <mat-icon>keyboard_arrow_up</mat-icon>
          <span>{{ 'SHARED_LABEL_MOVE_UP' | translate }}</span>
        </button>
        <button mat-menu-item (click)="moveDown.emit()">
          <mat-icon>keyboard_arrow_down</mat-icon>
          <span>{{ 'SHARED_LABEL_MOVE_DOWN' | translate }}</span>
        </button>
        <button mat-menu-item (click)="moveToLast.emit()">
          <mat-icon>keyboard_double_arrow_down</mat-icon>
          <span>{{ 'SHARED_LABEL_MOVE_TO_BOTTOM' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
}
